import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import GrayPanel from '../../components/GrayPanel';
import { formDict } from '../rejestracja/Rejestracja';
import { update_user } from '../../actions/user';
import s from './UserInfo.css';
import v from '../eservices/validators';
import ModalAlert from '../eservices/ModalAlert';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import waiting from '../eservices/images/waiting-wheel-300x300.gif';

const errorSpanStyle = {
  color: 'red',
  fontSize: '10px',
};


const userAdressDict = {
  profileID: null,
  AddressType: 'mailAddress',
  AddressCity: null,
  AddressStreet: null,
  AddressNumber: null,
  AddressFlat: null,
  AddressZipCode: null,
  AddressMail: null,
  AddressDistrict: null,
  AddressPrecint: null,
};


class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: this.props.userData,
      sectionsMap: new Map(),
      isEditingData: false,
      showModal: false,
      showLogoutModal: false,
      response: null,
      badDataReport: [],
      errors: {},
      errorTitle: '',
      errorText: '',
      showError: false,
      colors: 'normal',
      sourceStyle: layoutColorStyle,
      style: {},
      href: null,
    };

    this.validators = {
      LastName: [v.NotNull],
      FirstName: [v.NotNull],
      AddressCity: [v.NotNull],
      AddressDistrict: [v.NotNull],
      AddressPrecint: [v.NotNull],
      AddressStreet: [],
      url: [v.NotNull],
      // AddressStreet: [v.NotNull],
      AddressNumber: [v.NotNull],
      AddressMail: [v.NotNull],
      AddressZipCode: [v.NotNull, v.ExatctLength(6)],
      Email: [v.NotNull, v.CheckEmail],
      PhoneNumber: [v.NotNull, v.isNumber],
    };

    this.state.sectionsMap
    .set({ userData: 'Dane użytkownika' }, ['FirstName', 'LastName', 'FullName', 'Pesel', 'username'])
    .set({ epuapData: 'Dane profilu zaufanego' }, ['pzEmail', 'pzLogin', 'url'])
    // .set({ userDetails: 'Szczegóły użytkownika' }, ['Pesel', 'UserName'])
    .set({ companyData: 'Dane użytkownika' }, ['CompanyName'])
    .set({ companyDetails: 'Szczegóły użytkownika' }, ['Nip', 'Regon'])
    .set({ adress: 'Dane adresowe' }, ['AddressStreet', 'AddressNumber', 'AddressFlat', 'AddressZipCode', 'AddressMail', 'AddressCity', 'AddressDistrict', 'AddressPrecint'])
    .set({ contactData: 'Dane kontaktowe' }, ['Email', 'PhoneNumber']);

    this.createNewUser.bind(this);
    this.updateThisUser.bind(this);
  }

  hidden_fields = ['pzEmail', 'FullName', 'username', 'pzLogin']
  disabled_fields = ['FirstName', 'LastName', 'FullName', 'Pesel', 'username', 'pzLogin']

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    if (this.props.userData && !this.props.userData.loginConfirmed){
      const url = new URL(window.location.href);
      const href = url.searchParams.get('href');
      this.setState({
        errorText: 'Twoje konto nie posiada informacji niezbędnych do prawidłowego działania usług. Uzupełnij swój profil użytkowika',
        errorTitle: 'Uwaga!',
        showError: true,
        colors,
        sourceStyle,
        style,
        href,
      });

      return;
    }
    this.setState({ colors, sourceStyle, style });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    const newGroup = {
      ...this.state[group],
      [name]: e.target.value,
    };

    this.setState(
      {
        [group]: newGroup,
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['userData'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  userDataEdit = () => {
    this.setState({
      isEditingData: !this.state.isEditingData,
      userData: this.props.userData,
      badDataReport: [],
    });
  }

  validateBeforeModal = () => {
    this.validate(null, null, this.checkFieldErrors);
  }

  checkFieldErrors = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    this.showModalAlert();
  }

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  changeLocation = () => {
    if (this.state.href) {
      window.location.href = `/logout?href=${encodeURIComponent(this.state.href)}`;
    } else {
      window.location.href = '/logout';
    }
  }

  updateThisUser = () => {
    const data = JSON.stringify(this.state.userData);
    const successMessage = 'Zmiany zostały zapisane.';
    fetch(`${process.env.API_URL}/users/update/${this.state.userData.ID}`,
      {
        method: 'PATCH',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
    ).then((response) => {
      if (response.status == 200) {
        this.setState({
          showLogoutModal: true,
          showModal: false,
        }, () => this.afterSaving());
      } else {
        this.setState({
          errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
          errorTitle: 'Błąd zapisu danych.',
          showError: true,
        });
        return;
      }
      
    });
  }

  afterSaving = () => {
    setTimeout(() => {
      this.setState({
        showLogoutModal: false,
        showModal: false,
      }, () => this.changeLocation())}
      ,5000)
  }

  createNewUser = () => {
    const data = JSON.stringify(this.state.userData);
    const successMessage = 'Zmiany zostały zapisane.';
    fetch(`${process.env.API_URL}/users/create/`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
      ).then((response) => {
        if (response.status == 200) {
          this.setState({
            response: successMessage,
            showModal: false,
          }, () => this.changeLocation());
        } else {
          this.setState({
            errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
            errorTitle: 'Błąd zapisu danych.',
            showError: true,
          });
          return;
        }
        
      });
  }

  // po kliknieciu przycisku 'Zakmknij' w modalu response
  closeResponseModal = () => {
    this.state.badDataReport.length !== 0 ?
      this.setState({
        response: null,
        showLogoutModal: true,
      })
      :
      this.setState({
        response: null,
        isEditingData: false,
        showLogoutModal: true,
      });
  }

  onHide = () => this.setState({ showError: false });

  renderField = (key, value) => {
    const Labels = formDict.reduce(
      (res, item) => {
        return ({ ...res, [item.shortName]: item.label });
      }, {},
    );
    // zwraca odpowiednio zablokowane inputy dla danych ktorych nie powinnismy edytowac
    let isError = null;
    this.state.badDataReport.map((v, i) => {
      v === key ? isError = s.error : isError = null;
    });

    const isHidden = this.hidden_fields.indexOf(key) > -1;
    const isDisabled = this.disabled_fields.indexOf(key) > -1;

    return !isHidden ? (
      <div key={key}>
        <div className={s.usrKey}>{Labels[key]}</div>
          <div key={key}>
            <input
              onChange={(e) => this.onChange(e, 'userData')}
              type="text"
              name={key}
              disabled={isDisabled || !this.state.isEditingData}
              className={`form-control ${s.usrVal}`}
              value={value ? value : ''}
              style={{
                width: '100%',
                borderColor:
                  Object.keys(this.state.errors).indexOf(key) > -1 &&
                  this.state.errors[key] !== null &&
                  this.state.errors[key].length > 0
                    ? 'red'
                    : '#ccc',
              }}
            />
            {Object.keys(this.state.errors).indexOf(key) > -1 &&
            this.state.errors[key] !== null &&
            this.state.errors[key].length > 0
            ? this.state.errors[key].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
          : null}
          </div>
      </div>
    ) : null;
  };
  renderSection = (title, arr) => {
    return (
      <GrayPanel title={Object.values(title)[0]} key={Object.keys(title)[0]}>
        {arr.map(
          item => {
            return this.renderField(item, this.state.userData[item]);
          },
        )
        }
        {title.hasOwnProperty('epuapData') ? 
          <a
            target={'_blank'}
            href={'https://www.gov.pl/attachment/cc37dad0-524f-4222-82cb-1fe7aa39c83b'}
          >
            Znajdowanie adresu swojej skrytki na ePUAP
          </a>   
        : null}
      </GrayPanel>
    );
  };

  // modal z potwierdzeniem lub odrzuceniem zmian
  modalSeTaki = () => {
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={this.state.style}>
          <div className={s.modal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={s.usrButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.updateThisUser} className={`btn btn-success ${s.usrButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>
    );
  }

  // modal z gif-em w oczekiwaniu na wylogowanie
  logoutWaiting = () => {
    const message = 'Zmiany zostały zapisane. Za chwilę nastąpi wylogowanie.';
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={{ ...this.state.style, height: '300px' }}>
          <div className={s.modal__header}>
            <img src={waiting} style={{ height: '150px' }}/>
          </div>
          <div className={`${s.usrButtons} ${s.center}`}>
          {message}
          </div>
        </div>
      </div>
    );
  }

  // modal z komunikatem response pod wyslaniu zmian danych uzytkownika
  modalResponse = () => {
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={this.state.style}>
          <div className={s.modal__header}>{this.state.response}</div>
          <div className={`${s.usrButtons} ${s.center}`}>
            <button onClick={this.closeResponseModal} className="btn btn-success">Zamknij</button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={s.usrContainer} style={this.state.style}>
        <div className={s.usrTitle}>Dane:</div>
        <div className={s.usrButtons}>
          <button onClick={this.userDataEdit} className="btn btn-warning">{this.state.isEditingData ? 'Anuluj edycję' : 'Edytuj dane'}</button>
          {JSON.stringify(this.props.userData) !== JSON.stringify(this.state.userData) ?
            <button onClick={this.validateBeforeModal} className="btn btn-success">Zapisz zmiany</button>
            :
            null
          }
        </div>
        {
          [...this.state.sectionsMap].filter(
            ([k, v]) => {
              const sectionKeyKey = Object.keys(k)[0];
              return this.state.userData.IsPerson === true ?
                !['companyData', 'companyDetails'].includes(sectionKeyKey) :
                !['userData'].includes(sectionKeyKey);
            },
          ).map(
            ([k, v]) => this.renderSection(k, v),
          )
        }
        <p style={{ marginLeft: "30px;", paddingBottom: "10px;" }}>* - pole obowiązkowe</p>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        {this.state.showModal ? this.modalSeTaki() : null}
        {this.state.showLogoutModal ? this.logoutWaiting() : null}
        {this.state.response !== null ? this.modalResponse() : null}
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  update_user,
};

export default withStyles(s)(connect(mapState, mapDispatch)(UserInfo));




// WEBPACK FOOTER //
// src/routes/userInfo/UserInfo.js